import { ApplicationConfig, importProvidersFrom, ImportProvidersSource, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { appProviders } from './app.providers';
import { provideCalAngular } from '@cvx-dev/cal-angular';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { authInterceptor } from './shared/interceptors/auth.interceptor';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),

        provideRouter(routes),

        provideHttpClient(
          withInterceptorsFromDi(),
          withInterceptors([authInterceptor])
        ),

        provideAnimationsAsync(),

        providePrimeNG({
      theme: {
        preset: definePreset(Aura, {
          semantic: {
            primary: {
              50: '#eff6ff',
              100: '#dbeafe',
              200: '#bfdbfe',
              300: '#93c5fd',
              400: '#60a5fa',
              500: '#3b82f6',
              600: '#2563eb',
              700: '#1d4ed8',
              800: '#1e40af',
              900: '#1e3a8a',
              950: '#172554',
            },
          },
        }),
        options: {
          darkModeSelector: '.p-dark',
          cssLayer: true,
        },
      },
          zIndex: { modal: 1100, overlay: 1000, menu: 1000, tooltip: 1200 }
        }),

        importProvidersFrom(...appProviders as ImportProvidersSource[]),

        provideCalAngular(environment.calConfigPath)
    ]
};
